module.exports = "\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main